import getters from './getters'
import mutations from './mutations'

const state = {
    filters: [],
    changing: null
}

export default {
    namespaced: true,
    state,
    getters,
    mutations
}
